import React from 'react';
import { Alert, Button } from 'antd';
import { StopOutlined } from '@ant-design/icons';

export default function ImpersonationBanner({ targetUsername, onStop }) {
    return (
        <Alert
            title={`Impersonating: ${targetUsername}`}
            description={`You are currently impersonating user "${targetUsername}". Click stop to return to your admin account.`}
            type="warning"
            showIcon
            action={
                <Button size="small" danger icon={<StopOutlined />} onClick={onStop}>
                    Stop Impersonation
                </Button>
            }
            style={{ marginBottom: '1rem' }}
        />
    );
}
